import React, {useEffect, useState} from 'react'
import TitreRapport from './titre_rapport.js'
import GraphAleasRapport from './graphAleas_Rapport.js'
import GraphAleasNBjoursRapport from './graphAleasNbjours_Rapport.js'
import GraphAleasNBjoursRapport2 from './graphAleasNbjours_Rapport2.js'
import apiLink from '../../config.js'
import FooterPDF from './footer.js'

function PageAleasPDF({idExploit}) {
  const [ExploitMixte, setExploitMixte] = useState(false)
  const [ExploitViti, setExploitViti] = useState(false)
  const [ExploitGC,setExploitGC] = useState(true)

  const [dataMoy_SHRU_2D, setDataMoy_SHRU_2D] =  React.useState()
  const [dataMoy_SHRU_4D, setDataMoy_SHRU_4D] =  React.useState()
  const [dataMin_SHRU_2D, setDataMin_SHRU_2D] =  React.useState()
  const [dataMin_SHRU_4D, setDataMin_SHRU_4D] =  React.useState()
  const [dataMax_SHRU_2D, setDataMax_SHRU_2D] =  React.useState()
  const [dataMax_SHRU_4D, setDataMax_SHRU_4D] =  React.useState()
  const [dataQ1_SHRU_2D, setDataQ1_SHRU_2D] =  React.useState()
  const [dataQ1_SHRU_4D, setDataQ1_SHRU_4D] =  React.useState()
  const [dataQ3_SHRU_2D, setDataQ3_SHRU_2D] =  React.useState()
  const [dataQ3_SHRU_4D, setDataQ3_SHRU_4D] =  React.useState()
  const [dataNbjours_SHRU_2D, setdataNbjours_SHRU_2D] = React.useState()
  const [dataNbjours_SHRU_4D, setdataNbjours_SHRU_4D] = React.useState()
  const [dataNbjours_SHRU_Max_2D, setNBJ_SHRU_MAX_2D] = React.useState()
  const [dataNbjours_SHRU_Max_4D, setNBJ_SHRU_MAX_4D] = React.useState()
  const [dataNbjours_SHRU_Min_2D, setNBJ_SHRU_MIN_2D] = React.useState()
  const [dataNbjours_SHRU_Min_4D, setNBJ_SHRU_MIN_4D] = React.useState()
  const token = localStorage.getItem('token');

  function fetchData() {
    //fetch(apiLink + 'page/production-rapport/' + idExploit)
    
    fetch(apiLink + 'page/production-rapport' , {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',

        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        idExploitation: idExploit
      })
     })
    
    .then( (response) => {
    return response.json()
    })
    .then(response =>{
    let data = response
    for (var cle in data) {
        if (cle.includes("Vignes")) {
            setExploitMixte(true)
            setExploitGC(false)
            setExploitViti(false);
            break;
        }
    }
    let allKeysContainVignes = Object.keys(data).every(cle => cle.includes("Vignes"));
    if (allKeysContainVignes) {
        setExploitViti(true);
        setExploitMixte(false)
        setExploitGC(false)
    } else {
        setExploitViti(false);
    }
    })

    //fetch('https://api2050.diagorisk.com/pageAleas/?idExploitation=' + idExploit + '&idProduction=none')

        fetch('https://api2050.diagorisk.com/pageAleas/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          },
          body: JSON.stringify({
            idExploitation: idExploit,
            idProduction: 'none'
          })
        })

      .then((response) => response.json())
      .then((response) => {
        if ('error' in response) {
          // Si la réponse contient une erreur, relancer la requête après 60 secondes
          setTimeout(fetchData, 60000);
        } else {
          // Si la réponse est réussie, mettre à jour les données
          setDataMoy_SHRU_2D(response.dataMoy_SHRU_2D)
          setDataMoy_SHRU_2D(prev => {
            return prev;
          })
          setDataMoy_SHRU_4D(response.dataMoy_SHRU_4D)
          setDataMoy_SHRU_4D(prev => {
            return prev;
          })
          setDataMin_SHRU_2D(response.dataMin_SHRU_2D)
          setDataMin_SHRU_2D(prev => {
            return prev;
          })
          setDataMin_SHRU_4D(response.dataMin_SHRU_4D)
          setDataMin_SHRU_4D(prev => {
            return prev;
          })
          setDataMax_SHRU_2D(response.dataMax_SHRU_2D)
          setDataMax_SHRU_2D(prev => {
            return prev;
          })
          setDataMax_SHRU_4D(response.dataMax_SHRU_4D)
          setDataMax_SHRU_4D(prev => {
            return prev;
          })
          setDataQ1_SHRU_2D(response.dataQ1_SHRU_2D)
          setDataQ1_SHRU_2D(prev => {
            return prev;
          })
          setDataQ1_SHRU_4D(response.dataQ1_SHRU_4D)
          setDataQ1_SHRU_4D(prev => {
            return prev;
          })
          setDataQ3_SHRU_2D(response.dataQ3_SHRU_2D)
          setDataQ3_SHRU_2D(prev => {
            return prev;
          })
          setDataQ3_SHRU_4D(response.dataQ3_SHRU_4D)
          setDataQ3_SHRU_4D(prev => {
            return prev;
          })
          setdataNbjours_SHRU_2D(response.dataNbjours_SHRU_2D)
          setdataNbjours_SHRU_2D(prev => {
            return prev;
          })
          setdataNbjours_SHRU_4D(response.dataNbjours_SHRU_4D)
          setdataNbjours_SHRU_4D(prev => {
            return prev;
          })
          setNBJ_SHRU_MAX_2D(response.dataNbjoursMax_SHRU_2D)
          setNBJ_SHRU_MAX_2D(prev => {
            return prev;
          })
          setNBJ_SHRU_MAX_4D(response.dataNbjoursMax_SHRU_4D)
          setNBJ_SHRU_MAX_4D(prev => {
            return prev;
          })
          setNBJ_SHRU_MIN_2D(response.dataNbjoursMin_SHRU_2D)
          setNBJ_SHRU_MIN_2D(prev => {
            return prev;
          })
          setNBJ_SHRU_MIN_4D(response.dataNbjoursMin_SHRU_4D)
          setNBJ_SHRU_MIN_4D(prev => {
            return prev;
          })
        }
      })
      .catch((error) => {
        // Gérer les erreurs de la requête
        console.error('Erreur lors de la requête API :', error);
      });
  }
  useEffect ( () => {
    fetchData()
  }, [idExploit])
  
  return (
    <div className='containerPrint'>
      <TitreRapport Titre={'Impact du Stress hydrique'} Sous_Titre={"Sur toute l'exploitation"} Page={ExploitViti ? '0' : '5'}/>
      <div className='paragraphe'>Pour chaque aléa, nous comparons les impacts maximums, moyens et minimums pour toutes les cultures de l'exploitation et pour une scénario à +2°C ou +4°C.</div>
      <div className='titreMoins row' style={{marginBottom:'20px', marginTop:'40px'}}> Niveau des risques de 2020 à 2050 </div>
      <div className='row' style={{width:'100%'}}>
        <div style={{width:'50%'}}>
          {dataMax_SHRU_2D !== undefined ?<GraphAleasRapport myDataMax2D={dataMax_SHRU_2D} myDataMax4D={dataMax_SHRU_4D} aleas={'SH'} print={true} dataType={"Val"} type={'Max'}/> :""}
        </div>
        <div style={{width:'50%'}}>
          {dataMoy_SHRU_2D !== undefined ?<GraphAleasRapport myDataMoy2D={dataMoy_SHRU_2D} myDataMoy4D={dataMoy_SHRU_4D}  aleas={'SH'} print={true} dataType={"Val"} type={'Moy'}/> :""}
        </div>
      </div>
      
      <div className='titreMoins row' style={{marginBottom:'20px', marginTop:'40px'}}> Evolution entre 2020 et 2050</div>
      <div className='row'  style={{width:'100%'}}>
        <div style={{width:'50%'}}>
          {dataMax_SHRU_2D !== undefined ?<GraphAleasRapport myDataMax2D={dataMax_SHRU_2D} myDataMax4D={dataMax_SHRU_4D} aleas={'SH'} print={true} dataType={"Diff"} type={'Max'}/> :""}
        </div>
        <div style={{width:'50%'}}>
          {dataMoy_SHRU_2D !== undefined ?<GraphAleasRapport myDataMoy2D={dataMoy_SHRU_2D} myDataMoy4D={dataMoy_SHRU_4D}  aleas={'SH'} print={true} dataType={"Diff"} type={'Moy'}/> :""}
        </div>
      </div>
      <FooterPDF idExploit={idExploit} top={'-20px'} />
    </div>
  )
}

export default PageAleasPDF